import '@vuepic/vue-datepicker/dist/main.css';

import VueDatePicker from '@vuepic/vue-datepicker';
import {
  BAlert,
  BBadge,
  BButton,
  BButtonGroup,
  BCol,
  BCollapse,
  BDropdown,
  BDropdownDivider,
  BDropdownItem,
  BDropdownItemButton,
  BForm,
  BFormCheckbox,
  BFormCheckboxGroup,
  BFormGroup,
  BFormInput,
  BFormRadio,
  BFormRadioGroup,
  BFormRow,
  BFormSelect,
  BFormSpinbutton,
  BFormTextarea,
  BInputGroup,
  BModal,
  BPagination,
  BPopover,
  BRow,
  BSpinner,
  BTab,
  BTable,
  BTabs,
  BTooltip,
} from 'bootstrap-vue-next';
import { h } from 'vue';

import CopyText from '@/components/CopyText.vue';
import bFormLabel from '@/components/Forms/bFormLabel.vue';
import bInputNumber from '@/components/Forms/bInputNumber.vue';
import multiSelect from '@/components/Forms/VueMultiSelect.vue';
import IconSvg from '@/components/IconSvg.vue';
import BoxSimple from '@/components/Layout/BoxSimple.vue';
import registerNotify from '@/components/TheNotifications.js';

export default function registerComponents(app) {
  // Register plugins using app.use() in Vue 3
  registerNotify(app);

  app.component('BFormInput', BFormInput);
  app.component('BButton', BButton);
  app.component('BButtonGroup', BButtonGroup);
  app.component('BAlert', BAlert);
  app.component('BFormGroup', BFormGroup);
  app.component('BForm', BForm);
  app.component('BCol', BCol);
  app.component('BRow', BRow);
  app.component('BInputGroup', BInputGroup);
  app.component('BDropdownItem', BDropdownItem);
  app.component('BDropdownDivider', BDropdownDivider);
  app.component('BDropdownItemButton', BDropdownItemButton);
  app.component('BTab', BTab);
  app.component('BTabs', BTabs);
  app.component('BPopover', BPopover);
  app.component('BCollapse', BCollapse);
  app.component('BSpinner', BSpinner);
  app.component('BBadge', BBadge);
  app.component('BDropdown', BDropdown);
  app.component('BTooltip', BTooltip);
  app.component('BFormTextarea', BFormTextarea);
  app.component('BPagination', BPagination);
  app.component('BFormCheckbox', BFormCheckbox);
  app.component('BFormCheckboxGroup', BFormCheckboxGroup);
  app.component('BFormSpinbutton', BFormSpinbutton);
  app.component('BCheckbox', BFormCheckbox);
  app.component('BTable', BTable);
  app.component('BFormSelect', BFormSelect);
  app.component('BModal', BModal);
  app.component('BFormRadio', BFormRadio);
  app.component('BFormRadioGroup', BFormRadioGroup);
  app.component('BFormRow', BFormRow);

  // Register components using app.component() in Vue 3
  app.component('BInputNumber', bInputNumber);
  app.component('BFormLabel', bFormLabel);
  app.component('CopyText', CopyText);
  app.component('MultiSelect', multiSelect);
  app.component('SvgIcon', IconSvg);
  app.component('BoxSimple', BoxSimple);

  app.component('VueDatePicker', VueDatePicker);

  // Register `v-style` component inline using `app.component`
  app.component('VStyle', {
    render() {
      const defaultSlot = this.$slots.default;
      return h('style', defaultSlot ? defaultSlot() : undefined);
    },
  });
}
